<template>
  <div @click="details" :class="state ? 'bigitem' : 'item'">
    <div class="itembox">
      <div class="img">
        <img :src="data.imageUrl + '?imageView2/1'" alt="" />
      </div>
      <div class="name">{{ data.name }}</div>
      <div class="price">
        {{ data.sellPrice == 0 ? '议价' : '￥' + formatNumer(data.sellPrice) }}
      </div>
    </div>
  </div>
</template>
<script>
import { getPriceArrange, formatNumer } from '@/utils/index';
export default {
  props: ['data', 'state'],
  data() {
    return {};
  },
  created() {},
  methods: {
    getPriceArrange,
    formatNumer,
    details() {
      this.$router.push(`/index/details/${this.data.id}`);
    },
  },
};
</script>
<style lang="less" scoped>
.item {
  // width: 178px;
  width: 25%;
  margin-bottom: 20px;
  // flex: 1;
  // margin-right: 23px;
  padding: 0 10px;
  .itembox {
    // width: 178px;
    width: 100%;
    margin: 0 auto;
  }
  .img {
    width: 100%;
    height: 178px;
    background: #f1f1f1;
    border: none;
    margin-bottom: 14px;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .name {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
    line-height: 18px;
    margin-bottom: 8px;
    height: 36px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .price {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ff3e3e;
    line-height: 14px;
  }
}
.bigitem {
  // width: 376px;
  margin-bottom: 20px;
  // flex: 1;
  width: 50%;
  padding: 0 10px;
  .itembox {
    max-width: 376px;
    width: 100%;
    margin: 0 auto;
  }
  .img {
    // max-width: 376px;
    width: 100%;
    height: 376px;
    background: #f1f1f1;
    border: none;
    margin-bottom: 14px;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .name {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
    line-height: 18px;
    margin-bottom: 8px;
    height: 36px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .price {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ff3e3e;
    line-height: 14px;
  }
}
</style>
